export default "__VITE_ASSET__6d61483e__"